import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { blogPosts } from './blog/posts';
export function BlogPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Blog | IntelliEats';
    // Google AdSense - inject into <head>
    if (!document.querySelector('script[src*="adsbygoogle"]')) {
      const adsScript = document.createElement('script');
      adsScript.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3041826185319356';
      adsScript.async = true;
      adsScript.setAttribute('crossorigin', 'anonymous');
      document.head.appendChild(adsScript);
    }
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="pt-32 pb-24 bg-white min-h-screen" data-id="element-621">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-622">
        {/* Header */}
        <header className="mb-12 text-center" data-id="element-623">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-brand-600 hover:text-brand-700 mb-8 transition-colors" data-id="element-624">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-625" />
            Back to Home
          </Link>
          <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight leading-tight mb-4" data-id="element-626">
            The IntelliEats Blog
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-627">
            Insights, guides, and tips to help you understand what's really in
            your food and make smarter choices.
          </p>
        </header>

        {/* Post List */}
        <div className="space-y-8" data-id="element-628">
          {blogPosts.map((post, index) => <motion.div key={post.slug} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-629">
              <Link to={`/blog/${post.slug}`} className="group block bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden" data-id="element-630">
                <div className="grid sm:grid-cols-5 gap-0" data-id="element-631">
                  <div className="sm:col-span-2 overflow-hidden" data-id="element-632">
                    <img src={post.image} alt={post.imageAlt} className="w-full h-48 sm:h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-633" />
                  </div>
                  <div className="sm:col-span-3 p-6 sm:p-8 flex flex-col justify-center" data-id="element-634">
                    <div className="flex items-center gap-3 mb-3" data-id="element-635">
                      <span className="px-3 py-1 rounded-full bg-brand-50 text-brand-700 text-xs font-bold tracking-wider uppercase" data-id="element-636">
                        {post.category}
                      </span>
                      <span className="flex items-center text-xs text-slate-400" data-id="element-637">
                        <Clock className="w-3 h-3 mr-1" data-id="element-638" />
                        {post.readTime}
                      </span>
                    </div>
                    <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 leading-snug group-hover:text-brand-700 transition-colors" data-id="element-639">
                      {post.title}
                    </h2>
                    <p className="text-slate-600 text-sm leading-relaxed mb-4 line-clamp-3" data-id="element-640">
                      {post.excerpt}
                    </p>
                    <span className="inline-flex items-center text-sm font-semibold text-brand-600 group-hover:text-brand-700" data-id="element-641">
                      Read Article
                      <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-642" />
                    </span>
                  </div>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </div>
    </motion.div>;
}